// Single source of truth for FairFix contact details.
// Change these three lines ONLY to swap the business number sitewide —
// every tel:, sms: and JSON-LD reference on the site derives from them.
export const PHONE_DISPLAY = '0434 727 099';
export const PHONE_E164 = '+61434727099';
export const PHONE_TEL = `tel:${PHONE_E164}`;

// Google reviews — manually verified profile aggregate + short links.
// REVIEW_RATING is a display
// string so we render the exact number Corey sees on his profile ("5.0"),
// never a JS-rounded 5.
// REVIEW_COUNT source: FairFix Google Business Profile (CID
// 9010468055512646049), manually verified by Corey on 2026-10-08:
// 5.0 from 30 public reviews (26 written + 4 rating-only), all five stars.
// All 30 appear in data/reviews.js; the owner's separate pinned review is
// excluded. This is a manual snapshot, NOT an automatic Google sync.
export const REVIEW_COUNT = 30;
export const REVIEW_RATING = '5.0';
export const REVIEW_VERIFIED_AT = '2026-10-08';
export const GOOGLE_REVIEWS_URL = 'https://g.page/r/CaEB1vz0nAt9EAE';
export const GOOGLE_REVIEW_WRITE_URL = 'https://g.page/r/CaEB1vz0nAt9EAE/review';

// Prefilled SMS for a quote request. Format per RFC 5724:
//   sms:<recipient>?body=<url-encoded-message>
// Do NOT use the "?&body=" form (leading empty query param before "&"):
// iOS Safari silently fails to open the Messages app on that pattern —
// confirmed on a real device 2026-07-27.
// Base SMS URI (recipient only). Callers append their own url-encoded body.
export const SMS_BASE_URI = `sms:${PHONE_E164}?body=`;
export const SMS_QUOTE_LINK =
  SMS_BASE_URI + "Hi Corey, I'd like a quote for ";

// Verified business credentials (real values — never placeholders).
export const ABN = '95 386 997 041';
export const INSURANCE = 'Fully insured';
export const YEARS_EXPERIENCE = '20 Years Experience';
export const SERVICE_AREA_SHORT = 'Hobart & Surrounds';
// Owner qualification — verified. Exact wording enforced site-wide.
// A trade qualification (Certificate III in Carpentry) — NOT a builder's licence.
// Do NOT write "Licensed", "Registered", "Accredited" or invent a licence number.
export const CARPENTER_QUALIFICATION_SHORT = 'Qualified Carpenter · Cert III';
export const CARPENTER_QUALIFICATION_FULL = 'Qualified Carpenter — Certificate III in Carpentry';
export const CARPENTER_QUALIFICATION_FOOTER = 'Qualified Carpenter (Cert III)';

// Site-wide CTA labels — the ONLY two allowed CTA button strings.
// Enforce EVERY primary and secondary CTA imports these. If a component
// needs a different button label, either the label is wrong or the button
// isn't a "CTA" and should be reviewed.
// Primary = fills the purple button, links to #contact (the quote form).
// Secondary = outline/ghost button, is a tel: link.
export const CTA_PRIMARY_LABEL = 'Get My Free Quote';
export const CTA_SECONDARY_LABEL = 'Call Now';

// Business email — supporting contact channel (phone/SMS stays primary).
// ┌──────────────────────────────────────────────────────────────────────┐
// │ TODO(owner-swap): When Microsoft 365 mailbox on fairfix.com.au is    │
// │ live, change ONLY the string on the next line (e.g. to               │
// │ 'corey@fairfix.com.au' or 'info@fairfix.com.au'). EMAIL_LINK below   │
// │ and every displayed reference derive from it automatically.          │
// │ Also update NOTIFY_EMAIL in /app/backend/.env to the same address.   │
// └──────────────────────────────────────────────────────────────────────┘
export const EMAIL = 'corey@fairfix.com.au';
export const EMAIL_LINK = `mailto:${EMAIL}`;

// Social profile (single, understated — no feed/SDK, plain link only).
export const FACEBOOK_URL = 'https://www.facebook.com/share/1CZtDL3Ron/';

// Backend API base. A clone without environment configuration uses its own
// origin; a configured backend keeps its host/path without doubled slashes.
const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
export const API_BASE = `${BACKEND_ORIGIN}/api`;

// ─────────────────────────────────────────────────────────────────────────────
// Analytics — single source of truth for tracking IDs. Owner-swappable.
// ─────────────────────────────────────────────────────────────────────────────
// GA4 (Google Analytics 4) — LIVE. Property ID confirmed by owner.
// Change this string to point the site at a different GA4 property.
export const GA4_MEASUREMENT_ID = 'G-1ZT304PZLT';

// Meta (Facebook) Pixel — LIVE. Pixel ID confirmed by owner.
// Change this string to point the site at a different Pixel.
export const META_PIXEL_ID = '1934108570547345';
